
  // Nav
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => nav.classList.toggle('solid', window.scrollY > 50), {passive:true});

  // Hero zoom
  const hi = document.getElementById('heroImg');
  hi.complete ? hi.classList.add('loaded') : hi.addEventListener('load', () => hi.classList.add('loaded'));

  // Intersection observer — all fade variants
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('up'); io.unobserve(e.target); }});
  }, {threshold:.07, rootMargin:'0px 0px -24px 0px'});
  document.querySelectorAll('.fade,.fade-left,.fade-right,.fade-scale').forEach(el => io.observe(el));

  // Image parallax & motion handled via CSS scroll-timeline (composited, no scroll-thrash)

  // FAQ
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement, was = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if (!was) item.classList.add('open');
    });
  });

  // Form
  const form = document.getElementById('inquireForm');
  const ok   = document.getElementById('formOk');
  if (form) form.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('.btn-neon');
    btn.textContent = 'Sending…';
    try {
      const res = await fetch(form.action, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      if (res.ok) { form.style.display='none'; ok.style.display='block'; }
      else btn.textContent = 'Try again';
    } catch { btn.textContent = 'Try again'; }
  });

  // ── Intro gate: hero is a splash; scroll locked until "Enter" (JS-only, graceful without JS) ──
  const _body = document.body;
  _body.classList.add('locked');
  document.documentElement.classList.add('locked');
  function enterSite(){
    if (!_body.classList.contains('locked')) return;
    _body.classList.remove('locked');
    document.documentElement.classList.remove('locked');
  }
  const enterBtn = document.getElementById('enterBtn');
  if (enterBtn) enterBtn.addEventListener('click', () => {
    enterSite();
    const reel = document.getElementById('reel');
    if (reel) reel.scrollIntoView({ behavior: 'smooth' });
  });
  function _block(e){ if (_body.classList.contains('locked')) e.preventDefault(); }
  window.addEventListener('wheel', _block, {passive:false});
  window.addEventListener('touchmove', _block, {passive:false});
  window.addEventListener('keydown', e => {
    if (_body.classList.contains('locked') && [32,33,34,35,36,38,40].includes(e.keyCode)) e.preventDefault();
  }, {passive:false});

  // Smooth scroll (also exits the intro gate on any in-page link)
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      enterSite();
      if (href === '#') { e.preventDefault(); window.scrollTo({top:0, behavior:'smooth'}); return; }
      const t = document.querySelector(href);
      if (t) { e.preventDefault(); requestAnimationFrame(() => t.scrollIntoView({behavior:'smooth'})); }
    });
  });

  // Ripple
  (function() {
    const c = document.getElementById('ripple');
    if (!c) return;
    const ctx = c.getContext('2d');
    let w, h, t = 0;
    function resize() { w = c.width = c.offsetWidth; h = c.height = c.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, {passive:true});
    function draw() {
      ctx.clearRect(0,0,w,h);
      const cols=12, rows=9, cw=w/cols, ch=h/rows;
      for (let r=0; r<rows; r++) for (let col=0; col<cols; col++) {
        const wave=(cx,cy) => Math.sin(t*.55+cx*.72+cy*.48)*5 + Math.sin(t*.38+cx*.41-cy*.55)*3.5;
        const x=col*cw, y=r*ch;
        ctx.beginPath();
        ctx.moveTo(x,y+wave(col,r)); ctx.lineTo(x+cw,y+wave(col+1,r));
        ctx.lineTo(x+cw,y+ch+wave(col+1,r+1)); ctx.lineTo(x,y+ch+wave(col,r+1));
        ctx.closePath();
        const br=160+Math.sin(t*.4+col*.45+r*.35)*28;
        const al=0.025+Math.abs(Math.sin(t*.28+col*.5+r*.4))*.05;
        ctx.fillStyle=`rgba(${br},${Math.round(br*.94)},${Math.round(br*.88)},${al.toFixed(3)})`;
        ctx.fill();
      }
      t+=0.007; rafId=requestAnimationFrame(draw);
    }
    let running=false, rafId=0;
    const startStop = vis => {
      if (vis && !running) { running=true; draw(); }
      else if (!vis && running) { running=false; cancelAnimationFrame(rafId); }
    };
    if ('IntersectionObserver' in window) { new IntersectionObserver(es => startStop(es[0].isIntersecting), {threshold:0}).observe(c); }
    else startStop(true);
  })();

  // Looping inquiry video — ensure playback (autoplay fallback)
  (function(){
    const v = document.querySelector('.outro-video');
    if (!v) return;
    const go = () => { const p = v.play(); if (p && p.catch) p.catch(()=>{}); };
    go();
    v.addEventListener('canplay', go, {once:true});
    v.addEventListener('loadeddata', go, {once:true});
    ['click','touchstart','scroll','keydown'].forEach(ev =>
      document.addEventListener(ev, go, {once:true, passive:true}));
  })();
